import { GlobalpayThreeDSv2BrowserData, FormPaymentRequest, GlobalpayPaymentRequest } from "./types";
/**
 * Returns the color depth of the browser, or undefined if it cannot be determined.
 * If the color depth is not one of the valid values, it returns the highest valid 
 * value that is less than the browser's color depth.
 * Valid color depths are: 48, 32, 24, 16, 15, 8, 4, 1.
 * 
 * You may say "gee, why not just use the browser's color depth directly?"
 * 
 * Well, the authors of the 3DSv2 spec INCORRECTLY state that the color depth is an enum
 * and must be one of those values.
 * 
 * It is believed that the reason they did this was because the devil (w3schools.com),
 * which is the source of all evil, incorrectly stated that the color depth is an enum
 * and must be one of those values. This is not true, as browsers can report any value
 * they like, and in practice they do. So we have to map the browser's color depth
 * to one of the valid values.
 */
function get3DSv2ColorDepth(): number | undefined {
  const validDepths = [48, 32, 24, 16, 15, 8, 4, 1];
  const browserDepth =  window.screen?.colorDepth;
  if (browserDepth === undefined) {
    return undefined;
  }
  if (validDepths.includes(browserDepth)) {
    return browserDepth;
  }
  return Math.max(...validDepths.filter(depth => depth < browserDepth));
}

export function getCpsBrowserData(): GlobalpayThreeDSv2BrowserData {
  const now = new Date();
  const screen = window.screen;
  const navigator = window.navigator;
  return {
    colorDepth: get3DSv2ColorDepth(),
    javaEnabled: false,
    javascriptEnabled: true,
    language: navigator?.language,
    screenHeight: screen?.height,
    screenWidth: screen?.width,
    timezone: String(now.getTimezoneOffset() / 60),
    userAgent: navigator?.userAgent,
    acceptHeader:
      "text/html,application/xhtml+xml,application/xml;q=9,image/webp,img/apng,/;q=0.8",
    challengeWindowSize: "2",
  };
}

export function mapFormToGlobalpay(
  form: FormPaymentRequest,
  publicIpAddress: string,
  challengeCallbackUrl: string,
  browserData: GlobalpayThreeDSv2BrowserData
): GlobalpayPaymentRequest {
  const endDateMonth = parseInt(form.expiryMonth, 10) || 0;
  const endDateYear = parseInt(form.expiryYear, 10) || 0;
  const startDateMonth = parseInt(form.startMonth, 10) || 0;
  const startDateYear = parseInt(form.startYear, 10) || 0;
  return {
    address: form.address,
    amount: parseFloat(form.amount).toFixed(2),
    cardDetails: {
      cardNumber: form.cardNumber,
      endDateMonth,
      endDateYear,
      startDateMonth,
      startDateYear,
      issueNumber: 1,
    },
    securityCode: form.securityCode,
    name: form.name,
    postcode: form.postcode,
    threeDsv2Data: {
      browserData: { ...browserData, ipAddress: publicIpAddress },
      aboutUrl: "https://about.example.com",
      challengeUrl: challengeCallbackUrl,
      notificationUrl: "https://notify.example.com",
    },
  };
}
